export default {
  textCardLogged: (
    <>
      Utiliza esta ilustración científica <br /> junto con más de 75,000 opciones adicionales.{' '}
      <br /> Crea hermosos diseños de ciencia <br /> en cuestión de minutos con <br /> imágenes,
      dibujos e iconos de alta calidad.
    </>
  ),
  startCreatingNow: 'Comienza a Crear Ahora',
  loginForm: {
    login: 'Iniciar sesión en tu cuenta',
    joinUs: 'Únete a nosotros de forma gratuita',
  },
  registerFooter: {
    member: '¿Ya eres miembro?',
    login: 'Inicia sesión en su lugar',
  },
  initDescription: 'En',
  description:
    'es el icono perfecto para su brillante plantilla infográfica. Construya hermosas infografías y presentaciones científicas, académicas y educativas con esta ilustración, foto o dibujo.',
  customizeInit: 'Personalizar el',
  customizeDescription:
    'ilustración o dibujo según sea necesario, presentar o compartir su trabajo instantáneamente. Esta es una plantilla fue hecha por científicos, para científicos.',
  titleComplement: 'Ilustración e icono',
};
